export const GeneralConstant = {
    user: {
        role: {
            super_admin: 'super_admin',
            user: 'user',
        }
    }
}
